import React, { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Modal } from "react-materialize";
import { deleteMaterialClassification, getScrapFromOrganization } from "../../../../redux/action/classificationScrap";

function ExistingScrap({ setExistingScrap }) {
    const dispatch = useDispatch()
    const [deleteScrapStatus, setDeleteScrapStatus] = useState(false);
    const [modalOpen, setModalOpen] = useState(false)
    const [scrapItem, setScrapItem] = useState({})
    const { organizationScrap } = useSelector((state) => state.materialClassifications);

    const handleRemoveScrap = () => {
        dispatch(deleteMaterialClassification(scrapItem._id, setModalOpen, setScrapItem))
    }

    const closeModalConfirm = () => {
        setModalOpen(false);
        setScrapItem({})
    };

    useEffect(() => {
        dispatch(getScrapFromOrganization())
    }, [dispatch])

    useEffect(() => {
        setExistingScrap(organizationScrap)
    }, [organizationScrap, setExistingScrap])


    return (
        <div className="mt-1 flex column gap-1">
            <div className="valign-wrapper gap-1">
                <h5>Classifications</h5>
                <button
                    className={`button-style pointer cercle-purple-text`}
                    style={{
                        padding: "3px 15px",
                        border: "1px solid #6f2da8",
                    }}
                    onClick={() => setDeleteScrapStatus(!deleteScrapStatus)}>Edit
                </button>

            </div>
            <div className="valign-wrapper flex-wrap" style={{ gap: "1.5rem" }}>
                {organizationScrap?.map((item) => (
                    <span
                        className={`valign-wrapper justify-center gap-1`}
                        key={item?._id}
                        style={{
                            border: "1px solid #e7e7e7",
                            padding: "8px 20px",
                            borderRadius: "22px",
                        }}
                    >
                        <p className="font-16px cercle-purple-text">{item?.materialClassification}</p>
                        {deleteScrapStatus && (
                            <span className="material-icons-outlined pointer font-20px hover-red" onClick={() => { setModalOpen(true); setScrapItem(item) }}>
                                close
                            </span>
                        )}
                    </span>
                ))}
            </div>
            {organizationScrap?.length === 0 && <p className="font-16px flex justify-center">No classification found</p>}
            <Modal
                actions={[]}
                bottomSheet={false}
                fixedFooter={false}
                className="modelAccount"
                id="view-details"
                open={modalOpen}
                options={{
                    onCloseEnd: closeModalConfirm,
                }}
            >
                <div>
                    <h5 className="normal-size">Confirm to delete </h5>
                    <p className="semi-bold">
                        Are you sure to delete <b>{scrapItem?.materialClassification}</b>
                    </p>
                    <div className="flex justify-end gap-1">
                        <button className="green btn-small " onClick={handleRemoveScrap}>
                            Yes
                        </button>

                        <button
                            className="red btn-small"
                            onClick={() => setModalOpen(false)}
                        >
                            No
                        </button>
                    </div>
                </div>

            </Modal>
        </div>
    );
}

export default ExistingScrap;
